module.exports = __webpack_public_path__ + "17dcc6b5c9d186f61e6fbcdf1d051655.svg";